<template>
  <button id="show-more-button">
    <div class="jm-d-flex jm-align-items-center">
      {{ active ? 'En savoir moins' : ' En savoir plus' }}
      <img class="chevron" :class="{ active }" :src="chevronDown" />
    </div>
  </button>
</template>

<script>
import chevronDown from '@/assets/images/chevron-down-solid.png'

export default {
  name: 'ShowMoreButton',
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      chevronDown
    }
  }
}
</script>

<style lang="scss" scoped>
#show-more-button {
  // to overwrite the elementor button style from the wordpress editor
  font-family: $font-bold;
  border: none;
  background-color: transparent;
  text-transform: none;
  padding: 0;
  &:focus-visible,
  &:focus,
  &:hover {
    outline: none;
    border: none;
    color: $black;
    background-color: transparent;
  }

  .chevron {
    margin-left: $spacing-1;
    width: 14px;
    height: auto;
    vertical-align: bottom;
    &.active {
      transform: rotate(180deg);
    }
  }
}
</style>
